import { render, staticRenderFns } from "./hycot202.vue?vue&type=template&id=ed4ba056&scoped=true"
import script from "./hycot202.vue?vue&type=script&lang=js"
export * from "./hycot202.vue?vue&type=script&lang=js"
import style0 from "./hycot202.vue?vue&type=style&index=0&id=ed4ba056&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed4ba056",
  null
  
)

export default component.exports